import { render, staticRenderFns } from "./DialogSwiper.vue?vue&type=template&id=ce2efcc0&"
import script from "./DialogSwiper.vue?vue&type=script&lang=js&"
export * from "./DialogSwiper.vue?vue&type=script&lang=js&"
import style0 from "./DialogSwiper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports